import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as OrderHistoryActions from './orderhistory.actions';
import { ActionWithCorrelationAttributes } from '@kion/ngrx-helper';
import {
  OrderHistoryQuery
} from "@kion/libs/shared/data-access/data-access-orderhistory/src/lib/+state/orderhistory.selectors";
import {
  OrderHistoryPartialState
} from "@kion/libs/shared/data-access/data-access-orderhistory/src/lib/+state/orderhistory.reducer";

@Injectable()
export class OrderHistoryFacade {

  all$ = this.store.pipe(select(OrderHistoryQuery.getAllOrderHistory));
  allById$ = this.store.pipe(select(OrderHistoryQuery.getAllOrderHistoryById));
  searchResults$ = this.store.pipe(select(OrderHistoryQuery.getSearchResults));
  isSearching$ = this.store.pipe(select(OrderHistoryQuery.getIsSearching));
  lastCreatedId$ = this.store.pipe(select(OrderHistoryQuery.getLastCreatedId));
  query$ = this.store.pipe(select(OrderHistoryQuery.getQuery));
  pagination$ = this.store.pipe(select(OrderHistoryQuery.getPagination));

  constructor(private store: Store<OrderHistoryPartialState>) { }

  protected dispatch(action, correlationId?: string): ActionWithCorrelationAttributes {
    if (correlationId) {
      action.__correlationId = correlationId;
    }
    this.store.dispatch(action);
    return action;
  }

  /*
  loadOrderById(orderNumber: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(
      OrdersActions.loadById({ orderNumber: orderNumber }),
      correlationId
    );
  }
  */

  loadOrderHistoryById(orderNumber: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(
       OrderHistoryActions.loadOrderHistoryById({ orderNumber: orderNumber }),
       correlationId
    );
  }

  update(
      orderId: string,
      note: string,
      poNumber: string,
      correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
        OrderHistoryActions.update(
            {
              orderId: orderId,
              note: note,
              poNumber: poNumber
            }
        ),
        correlationId
    )
  }

  search(
     query?: string,
     useState: boolean = false,
     useDefaultPage: boolean = false,
     sort?: string,
     mixedMode: boolean = false,
     correlationId?: string,
     myOrders?: boolean,
     truckId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
       OrderHistoryActions.search({
         query: query,
         useState: useState,
         useDefaultPage: useDefaultPage,
         myOrders: myOrders,
         truckId: truckId,
         sort: sort
       }),
       correlationId
    );
  }

  updateQuery(queryPart: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(
        OrderHistoryActions.updateQuery({query: queryPart}),
        correlationId
    )
  };

  updatePerPage(
      perPage: number,
      correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
        OrderHistoryActions.updatePerPage({perPage: perPage}),
        correlationId
    );
  }

  updatePage(
     page: number,
     correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
       OrderHistoryActions.updatePage({ page: page }),
       correlationId
    );
  }
}
